/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTypesControllerFindAllQueryResponse, ProjectTypesControllerFindAllQueryParams, ProjectTypesControllerFindAll401, ProjectTypesControllerFindAll403 } from "../../models/projectTypesController/ProjectTypesControllerFindAll";

function getProjectTypesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/project-types` as const }  
  return res
}

/**
 * @summary Get all project types
 * {@link /api/v1/project-types}
 */
export async function projectTypesControllerFindAll(params?: ProjectTypesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectTypesControllerFindAllQueryResponse, ResponseErrorConfig<ProjectTypesControllerFindAll401 | ProjectTypesControllerFindAll403>, unknown>({ method : "GET", url : getProjectTypesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}